import React from "react";
import { TFunction } from "i18next";
import { Tooltip } from "@mui/material";
import classnames from "classnames";
import { TrashIcon } from "@aureskonnect/react-ui";

import ErrorToast from "@components/Common/ErrorTost";
import { onKeyboardActivate } from "@helpers/a11y";

type Props = {
    row: any;
    t: TFunction;
};

export default function ArchiveIconButton({ row, t }: Props) {
    const isActiveState = row[t("State")] === true;
    const handleClick = () => {
        ErrorToast(
            `${t(
                "Please note, loyalty archiving is done exclusively by the franchise."
            )!}`
        );
    };

    return (
        <Tooltip title={isActiveState ? "" : t("Archive")}>
            <div
                data-testid={`fidelity-shops-archive-icon-${row.Id}`}
                role="button"
                tabIndex={isActiveState ? -1 : 0}
                aria-label={t("Archive")}
                aria-disabled={isActiveState}
                onKeyDown={onKeyboardActivate(handleClick)}
            >
                <TrashIcon
                    onClick={handleClick}
                    height={25}
                    width={25}
                    fill="red"
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "pointer__clz mt-2 cmn_icn_BTarchived"
                    )}
                />
            </div>
        </Tooltip>
    );
}
